import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=4cfd22de&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cfd22de')) {
      api.createRecord('4cfd22de', component.options)
    } else {
      api.reload('4cfd22de', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=4cfd22de&", function () {
      api.rerender('4cfd22de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tHAhwZVo8U9Y/JS/comp/childrenage.vue"
export default component.exports